import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiService } from 'src/app/services/api.service';
import { environment} from '../../../environments/environment';

@Component({
  selector: 'app-admin-forgot-password',
  templateUrl: './admin-forgot-password.component.html',
  styleUrls: ['./admin-forgot-password.component.scss']
})
export class AdminForgotPasswordComponent implements OnInit {

  forgetPasswordForm:any;
  submitted = false;
  password:string='';
  re_password:string=''; closeResult: any = '';
  userId:any='';suucessMsgForget:any='';
   //private BASE_URL: string = 'http://localhost:4200/';
   private BASE_URL: string = environment.BASEURL+'#/admin-login';
  // private BASE_URL: string = environment.BASEURL+'admin-login';
  errorInfo:{isError:boolean,errorMsg:string} = {isError:false,errorMsg:''}
  constructor(private auth:ApiService,
    private route: ActivatedRoute,
    private router: Router,private spinner: NgxSpinnerService,private formbuilder:FormBuilder,private modalService: NgbModal) {

    this.forgetPasswordForm = this.formbuilder.group({
      email: new FormControl('', [Validators.required, Validators.email,
        Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]),
        link: new FormControl(this.BASE_URL)
    })
  }

  ngOnInit(): void {
  }
  open(content: any) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  get f() { return this.forgetPasswordForm.controls; }
  forgetPass(form:any){
    this.submitted = true;
     //stop here if form is invalid
     if (this.forgetPasswordForm.invalid) { return; }
    //console.log(this.forgetPasswordForm.value);return false;
     this.spinner.show();
     this.auth.forgetPassword(this.forgetPasswordForm.value).subscribe(
       data => {
          if(data.status == 200){
            this.spinner.hide();
            this.suucessMsgForget = 'Your password has been sent to the registered Email ID';
            document.getElementById('successMsg')?.click();
            this.router.navigateByUrl('/'); 
          } else if(data.status == 400){
            this.spinner.hide();
            this.errorInfo.isError = true;
            this.errorInfo.errorMsg = data.message;
          }
       },
       error => {
        this.spinner.hide();
        //alert(error);
      });  
  }

}